import { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import InquiryForm from "@/components/InquiryForm";

const InquiryContext = createContext({ open: () => {} });
export const useInquiry = () => useContext(InquiryContext);

export const InquiryProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [preset, setPreset] = useState("");

  const open = (presetProjectType = "") => {
    setPreset(presetProjectType);
    setIsOpen(true);
  };

  return (
    <InquiryContext.Provider value={{ open }}>
      {children}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent
          data-testid="inquiry-modal"
          className="max-w-2xl max-h-[90vh] overflow-y-auto bg-cream border-champagne/40 rounded-2xl p-6 sm:p-10"
        >
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl sm:text-3xl text-charcoal tracking-tight">
              Tell us about your project.
            </DialogTitle>
            <DialogDescription className="font-sans text-sm text-taupe">
              Share a few details and we'll follow up with a personalized quote. No account
              needed — this takes about two minutes.
            </DialogDescription>
          </DialogHeader>
          <div className="mt-6">
            {isOpen && (
              <InquiryForm
                key={preset}
                preset={preset}
                testPrefix="inquiry"
                onClose={() => setIsOpen(false)}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </InquiryContext.Provider>
  );
};

export default InquiryProvider;
